import { render, staticRenderFns } from "./TabChat.vue?vue&type=template&id=a2ae4532"
import script from "./TabChat.vue?vue&type=script&lang=js"
export * from "./TabChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports